<template>
  <div class="containers">
    <div class="titleLine flex">
      <div>业务</div>
      <div>实名认证</div>
      <div>小微商户</div>
      <div>个体商户</div>
      <div>企业商户</div>
    </div>
    <div class="flex subLine">
      <div>付款码</div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
    </div>
    <div class="flex subLine">
      <div>快捷支付</div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/fails.png" alt />
      </div>
    </div>
    <div class="flex subLine">
      <div>小额闪付</div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/fails.png" alt />
      </div>
    </div>
    <div class="flex subLine">
      <div>刷脸付</div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/fails.png" alt />
      </div>
    </div>
    <div class="flex subLine">
      <div>手机POS</div>
      <div>
        <img src="../../assets/img/fails.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
    </div>
    <div class="flex subLine">
      <div>收款码</div>
      <div>
        <img src="../../assets/img/fails.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
      <div>
        <img src="../../assets/img/sucs.png" alt />
      </div>
    </div>
    <!-- <div class="beizhu">
      注：个体商户、企业商户认证时需要上传授权协议
      <span @click="doDownLoad">下载授权协议模板</span>
    </div> -->
  </div>
</template>
<script>
export default {
  created() {
    document.title = "认证说明";
  },
  methods: {
    //下载文件
    doDownLoad() {
      window.location.href = '/Template.doc';
    }
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.containers {
  padding: 10px;
  /* margin-top: 10px; */
  width: 100%;
  height: 100vh;
  background: #f6f6f6;
  box-sizing: border-box;
}
div {
  font-size: 14px;
  white-space: nowrap;
  /*空白不换行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*显示省略号*/
}
.flex {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.flex > div {
  width: 19.5%;
  text-align: center;
}
.titleLine > div {
  height: 40px;
  line-height: 40px;
  background: #d6dce3;
  font-weight: bold;
}
.subLine > div {
  height: 70px;
  line-height: 70px;
  background: #dcece2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.subLine > div:first-of-type {
  background: #e4e9ee;
}
.containers > div {
  margin-top: 3px;
}
.beizhu{
  margin: 15px !important;
  overflow:visible;
  white-space:normal
}
.beizhu span{
  color: #1989fa;
}
</style>